// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "svg[data-v-599cc5e1]{margin-left:5px;width:13px}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/Dashboard/ArrowDownIcon.vue"],"names":[],"mappings":"AACA,qBAEE,eAAA,CADA,UACF","sourcesContent":["\nsvg {\n  width: 13px;\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
